import { useState } from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Check, X } from "lucide-react";
import { toast } from "@/components/ui/use-toast";
import { getAdminAuthConfig } from "../../lib/adminAuth";
const BackendUrl = process.env.REACT_APP_Backend_Url;
const ToggleAvailabilityButton = ({
  productId,
  onSuccess,
  isAvailable,
  setIsAvailable,
}) => {
  const [loading, setLoading] = useState(false);

  const handleToggle = async () => {
    setLoading(true);
    try {
      const response = await axios.patch(
        `${BackendUrl}/api/productsRoutes/${productId}/toggle-availability`,
        {},
        getAdminAuthConfig()
      );
      const updatedStatus = response.data.data.isdisponible;
      //   alert(updatedStatus);
      setIsAvailable(updatedStatus);
      toast({
        title: "Succès",
        description: `Produit ${
          updatedStatus ? "activé" : "désactivé"
        } avec succès`,
      });

      // callback optionnel pour informer le parent
      if (onSuccess) onSuccess(updatedStatus);
    } catch (error) {
      console.error(error);
      toast({
        title: "Erreur",
        description: "Impossible de modifier l'état du produit.",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant={isAvailable ? "destructive" : "default"}
      onClick={handleToggle}
      disabled={loading}
    >
      {loading ? (
        "Chargement..."
      ) : (
        <>
          {isAvailable ? (
            <>
              <X className="w-4 h-4 mr-2" />
              Désactiver
            </>
          ) : (
            <>
              <Check className="w-4 h-4 mr-2" />
              Activer
            </>
          )}
        </>
      )}
    </Button>
  );
};

export default ToggleAvailabilityButton;
